import "../jquery-setup"

var bindAutoCompleteCard = function() {
  $(".autocomplete-card").autocomplete({
    source: "/autocomplete_card",
    select: function(event, ui) {
      //assign value back to the form element
      if(ui.item.value){
        var card_id = ui.item.value;
        this.value = card_id;
      }
      return false;
    }
  });
}
window.bindAutoCompleteCard = bindAutoCompleteCard;

bindAutoCompleteCard();

// binds by card -id
var bindCardAutoComplete = function() {
  bindSearchAutoComplete($('.autocomplete-card-id'), null, null, false);
  bindSearchAutoComplete($('.autocomplete-card-id-submit'), null, null, true);

  $(".layout-search-input-field").omnicomplete({
    source: "/autocomplete_omni",
    classes: { "ui-autocomplete": "autocomplete-omni", },
    select: function(event, ui) {
      window.location = ui.item.url;
      $(".layout-search-input-field").attr('readonly', true);
      $(".layout-search-submit").attr('disabled','disabled');
    },
  });
};

window.bindCardAutoComplete = bindCardAutoComplete;

$.extend($.ui.menu.prototype, {
	isFirstItem: function() {
		if (this.options.subcontainers) {
			if (this.active) {
				if (this.active.prevAll( ".ui-menu-item" ).length) {
					return false;
				} else {
					return !this.active.closest(this.options.subcontainers).prevAll(this.options.subcontainers).eq(0).find(".ui-menu-item").length;
				}
			}
			return false;
		} else {
			return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
		}
	},

	isLastItem: function() {
		if (this.options.subcontainers) {
			if (this.active) {
				if (this.active.nextAll( ".ui-menu-item" ).length) {
					return false;
				} else {
					return !this.active.closest(this.options.subcontainers).nextAll(this.options.subcontainers).eq(0).find(".ui-menu-item").length;
				}
			}
			return false;
		} else {
			return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
		}
	},
	_move: function( direction, filter, event ) {
		console.log("menu _move");
		var next;
		if ( this.active ) {
			console.log("_move.active:" + this.active.text());

			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );

				if (this.options.subcontainers && (!next || !next.length)) {
				  // find parent subcontainer, get the sibling subcontainer in the correct direction, then find the appropriate item
					next = this.active.closest(this.options.subcontainers)[ direction === "first" ? "prevAll" : "nextAll" ](this.options.subcontainers).find(this.options.items)[filter]();
				}
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
				if (this.options.subcontainers && (!next || !next.length)) {
				  // find parent subcontainer, get the sibling subcontainer in the correct direction, then find the appropriate item
					next = this.active.closest(this.options.subcontainers)[ direction  + "All" ](this.options.subcontainers).find(this.options.items)[filter]();
				}
			}
		} else {
			console.log("_move.!active");
    }
		if ( !next || !next.length || !this.active ) {
      if (this.options.subcontainers) {
        if (filter === "first" || filter === "last") {
          next = this.activeMenu.closest(".ui-menu").find(this.options.subcontainers).eq(filter === "first" ? 0 : -1).find(this.options.items)[filter]();
        }
      }
      if (!next) {
        next = this.activeMenu.find( this.options.items )[ filter ]();
      }
		}

		this.focus( event, next );
	},
  /*
	focus: function( event, item ) {
		console.log("menu.focus");
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		//this.activeMenu = item.parent().closest(this.options.menu);
		this.activeMenu = item.parent();


		this._trigger( "focus", event, { item: item } );
	},
*/
});

$.extend($.ui.autocomplete.prototype, {

	_renderMenu: function (ul, items) {
		//remove scroll event to prevent attaching multiple scroll events to one container element
		$(ul).unbind("scroll");

		var self = this;
		self._scrollMenu(ul, items);
	},
	_move: function( direction, event ) {
		console.log("omni _move");
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

  _resizeMenu: function() {
    var ul = this.menu.element;
    ul.outerWidth( Math.max(
      // Firefox wraps long text (possibly a rounding bug)
      // so we add 1px to avoid the wrapping (#7513)
      // mtggoldfish: change 1 to 10 to fix chrome wrapping
      // 30 works for all browsers but IE
      ul.width( "" ).outerWidth() + 40,
      this.element.outerWidth()
    ) );
  },

	_scrollMenu: function (ul, items) {

		var self = this;
		var maxShow = 10;
		var results = items;

    var term = self.term;
    var pageIndex = 1;

    $(ul).scroll(function () {
      if (pageIndex > 0 && isScrollbarBottom($(ul))) {
        ++pageIndex;
      //	console.log("scroll bar bottom");
        //console.log("window.pageIndex:"  + window.pageIndex);
        //console.log("pages:"  + pages);
        var url = self.options.source;
        //var url = "/autocomplete";
        var request = { term: term, page: pageIndex };

        $.ajax( {
          url: url,
          data: request,
          dataType: "json",
          success: function( results ) {
            if (results.length == 0) {
              pageIndex = -1;
            }
            $.each(results, function (index, item) {
              self._renderItemData(ul, item);
            });

            //refresh menu
            //self.menu.deactivate();
            self.menu.refresh();
            // size and position menu
            ul.show();
            self._resizeMenu();
            ul.position($.extend({
                of: self.element
            }, self.options.position));
            if (self.options.autoFocus) {
                self.menu.next(new $.Event("mouseover"));
            }
          },
          error: function() {
            //response( [] );
          }
        } );
      }
    });

		$.each(results, function (index, item) {
				self._renderItemData(ul, item);
		});
	}
});

function isScrollbarBottom(container) {
	 var height = container.outerHeight();
	 var scrollHeight = container[0].scrollHeight;
	 var scrollTop = container.scrollTop();
	 if (scrollTop >= scrollHeight - height) {
			 return true;
	 }
	 return false;
};

var bindSearchAutoComplete = function(autocompleteElements, searchBox, searchButton, submit) {
  if (autocompleteElements.length > 0) {
    $.each((autocompleteElements), function(index, item) {
      const autocompleteElement = $(item);
      autocompleteElement.autocomplete({
        source: "/autocomplete",
        select: function(event, ui) {
          //assign value back to the form element
          if(ui.item){
            $(event.target).val(ui.item.id);
          }

          if (searchBox != null && searchButton != null) {
            searchBox.attr('readonly', true)
            searchButton.attr('disabled','disabled');
          }


          if (submit) {
            $(event.target.form).find(".autocomplete-card-id-submit").attr("readonly", true);
            $(event.target.form).find("input[type=submit]").attr("disabled", "disabled");
            $(event.target.form).submit();
          } else {
            return false;
          }
        }
      }).data( "ui-autocomplete" )._renderItem = function( ul, item ) {
        var description = item.name + " " + item.set;
        var content = "<a><div class='search-card-name'>";

        content += item.name;

        if (item.card_num) {
          content += "<span class='card-num'>#" + item.card_num + "</span>";
        }

        var hasFoilTag = false;
        if (item.tags && item.tags.length > 0) {
          item.tags.forEach(function(tag) {
            if (tag.toLowerCase().indexOf("foil") !== -1) { hasFoilTag = true; }
            var tagLabel = tag.replace(/\b\w/g, function(c) { return c.toUpperCase(); });
            content += "<span class='badge badge-variation'>" + tagLabel + "</span>";
          });
        }

        if (!hasFoilTag && item.finish && item.finish !== "regular") {
          var finishLabel = item.finish.replace(/_/g, " ").replace(/\b\w/g, function(c) { return c.toUpperCase(); });
          content += "<span class='badge badge-variation'>" + finishLabel + "</span>";
        }

        content += "</div><span class='search-set-name'>" + (item.set || "") + "</span></a>";
        return $("<li aria-label='" + description.replace(/'/g, "&#39;") + "'>")
        .append(content)
        .appendTo( ul );
      };
    });
  }
}
window.bindSearchAutoComplete = bindSearchAutoComplete;

$(function() {
	$.widget( "custom.omnicomplete", $.ui.autocomplete, {
		_create: function() {
			this._super();
			//this.widget().menu( "option", "items", "> :not(.autocomplete-omni-left-column)" );
			this.widget().menu( "option", "items", ".ui-autocomplete-item" );
			this.widget().menu( "option", "subcontainers", ".ui-autocomplete-omni-subcontainer" );
			//this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
		},
    _renderMenu: function( ul, items ) {
      var that = this;
      var cards = [];
      var decks = [];
      var articles = [];
      var tournaments = [];
      var links = [];

      $.each( items, function( index, item ) {
        if ("card" in item) {
          cards.push(item);
        } else if ("deck" in item) {
          decks.push(item);
        } else if ("article" in item) {
          articles.push(item);
        } else if ("tournament" in item) {
        console.log(item);
          tournaments.push(item);
        } else if ("link" in item) {
          links.push(item);
        }
      });

      var myUL = $("<div class='ui-autocomplete-omni-left-container ui-autocomplete-omni-subcontainer'></div>");
      ul.append(myUL);

      
      if (cards.length == 0) {
        myUL.append( "<li class='search-last-card search-no-card'>No cards found.</li>" );
      } else {
        $.each( cards, function( index, item ) {
          that._renderItemData( myUL, item );
        });
      }

      if (links.length > 0 && links[0].link.category == "card") {
          that._renderItemData(myUL, links.shift());
      }

      var myUL = $("<div class='ui-autocomplete-omni-right-container ui-autocomplete-omni-subcontainer'></div>");
      ul.append(myUL);
      //var myUL = ul;

      myUL.append("<li class='ui-autocomplete-category search-category-decks'><span ui-autocomplete-category><img class='search-category-icon' src='<%= asset_path('layout/icon-search-decks.svg')%>'>Decks</span></li>" );
      if (decks.length != 0) {
        $.each( decks, function( index, item ) {
          that._renderItemData( myUL, item );
        });
      } else {
        myUL.append( "<li class='search-no-card'>No decks found.</li>" );
      }
      
      if (links.length > 0 && links[0].link.category == "deck") {
          that._renderItemData(myUL, links.shift());
      }

      myUL.append("<li class='ui-autocomplete-category search-category-tournaments'><span ui-autocomplete-category><img class='search-category-icon' src='<%= asset_path('layout/icon-search-tournaments.svg')%>'>Tournaments</span></li>" );
      if (tournaments.length != 0) {
        $.each( tournaments, function( index, item ) {
          that._renderItemData( myUL, item );
        });
      } else {
        myUL.append( "<li class='search-no-card'>No tournaments found.</li>" );
      }
      
      if (links.length > 0 && links[0].link.category == "tournament") {
          that._renderItemData(myUL, links.shift());
      }

      myUL.append("<li class='ui-autocomplete-category search-category-articles'><span><img class='search-category-icon' src='<%= asset_path('layout/icon-search-articles.svg')%>'>Articles</span></li>" );
      if (articles.length != 0) {
        $.each( articles, function( index, item ) {
          that._renderItemData( myUL, item );
        });
      } else {
        myUL.append( "<li class='search-no-card'>No articles found.</li>" );
      }
      if (links.length > 0 && links[0].link.category == "article") {
          that._renderItemData(myUL, links.shift());
      }
    },
    _renderItem: function( ul, obj ) {
      if ("card" in obj) {
        var item = obj.card;
        return $("<li class='ui-autocomplete-item autocomplete-item-card'>")
        .append("<a>" +  item.name + "</a>").appendTo( ul );
      } else if ("deck" in obj) {
        var deck = obj.deck;
        return $("<li class='ui-autocomplete-item autocomplete-item-deck'>")
        .append("<a>" +  deck.name + "<span class='search-deck-format'>(" + deck.format + ")</span>" + "</a>")
        .appendTo( ul );
      } else if ("article" in obj) {
        var article = obj.article;
        title = article.title.length > 40 ? $.trim(article.title.substring(0,39)) + "..." : article.title
        return $("<li class='ui-autocomplete-item autocomplete-item-article'>")
        .append("<a>" + title + "</a>")
        .appendTo( ul );
      } else if ("link" in obj) {
        var link = obj.link;
        if (link.name.match(/See More Cards/)) {
          return $("<li class='ui-autocomplete-item autocomplete-item-link autocomplete-item-see-more-cards'><a><img class='search-advanced-icon' src='<%= asset_path('layout/icon-search-more.svg')%>'>" + link.name + "</a></li>" ).appendTo( ul );
        } else {
          return $("<li class='ui-autocomplete-item autocomplete-item-link'><a><img class='search-advanced-icon' src='<%= asset_path('layout/icon-search-more.svg')%>'>" + link.name + "</a></li>" ).appendTo( ul );
        }
      } else if ("tournament" in obj) {
        var tournament = obj.tournament;
        return $("<li class='ui-autocomplete-item autocomplete-item-tournament'>")
        .append("<a>" +  tournament.name + "</a>")
        .appendTo( ul );
      }
    },
    _resizeMenu: function() {
      var ul = this.menu.element;
      ul.outerWidth( Math.max(
        // Firefox wraps long text (possibly a rounding bug)
        // so we add 1px to avoid the wrapping (#7513)
        // mtggoldfish: change 1 to 10 to fix chrome wrapping
        // 30 works for all browsers but IE
        ul.width( "" ).outerWidth() + 40,
        this.element.outerWidth()
      ) );
    },
	});
});


$(function() {
  bindCardAutoComplete();
  $("#layout-login-signup-btn").click(function() {
    $("#layout-login-signup-form").submit();
  });

});
window.bindAutoCompleteCard = bindAutoCompleteCard;
